import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Discover = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="discover">
      <div className="discover__container container">
        <div className="discover__info">
          <span>{translations[selectedLanguages].discover.subtitle}</span>
          <h2>{translations[selectedLanguages].discover.title}</h2>
          <p>{translations[selectedLanguages].discover.context}</p>
          <Link to="/contact">
            {translations[selectedLanguages].discover.button}
          </Link>
        </div>
        <div className="discover__images">
          <img src={Imgs.discoverImg} alt="discover" />
          <img src={Imgs.discoverfirst} alt="discover" />
        </div>
      </div>
    </section>
  );
};

export default Discover;
